const PRODUCTION_API_BASE = "https://lesson-booker-firebase.onrender.com";

export const API_BASE = process.env.REACT_APP_API_BASE || PRODUCTION_API_BASE;
